<template>
        <card>
           <template slot="header">
              <h3 class="card-title">Employee Accounts</h3>
           </template>
           <div class="table-responsive ">
              <table class="table table-striped table-hover ">
                 <thead>
                    <tr>
                       <th> <input type="checkbox"></th>
                       <th>Id</th>
                       <th>Question</th>
                       <th>Description</th>
                       <th>Created</th>
                       <!-- <th>Updated</th> -->
                       <th>Status</th>
                       <th>Action</th>
                    </tr>
                 </thead>
                 <tbody>
                    <tr>
                    </tr>
                 </tbody>
              </table>
           </div>
        </card>
     </template>
<script>
    /* eslint-disable */
    import Card from 'src/components/UIComponents/Cards/Card.vue'

    export default {
        components: {
            Card
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-employee-accounts/todo-employee-account.vue